import dayjs from 'dayjs';
import { Box } from '@mui/material';
import { FaCircle, FaRegCalendarAlt, FaRegClock } from 'react-icons/fa';
import { Tag } from 'components';
import convertToReadable from 'services/helpers';

export const columns = [
  {
    field: 'notification',
    headerName: 'Оповещение',
    renderCell: (data: any) => {
      return (
        <Box display='flex' gap='15px' alignItems='center' justifyContent='flex-start'>
          <FaCircle color={data?.status === 'waiting' ? data?.color : '#A7ACB0'} />
          <Box display='flex' gap='5px' alignItems='center'>
            <FaRegCalendarAlt />
            {dayjs(data?.control_date).format('DD/MM/YYYY')}
          </Box>
          <Box display='flex' gap='5px' alignItems='center'>
            <FaRegClock />
            {data?.control_time}
          </Box>
        </Box>
      );
    },
    width: 180,
  },
  {
    field: 'status',
    headerName: 'Статус',
    renderCell: (data: any) => (
      <Tag variant={data.status === 'waiting' ? 'active' : 'in_active'}>
        {data.status === 'waiting' ? 'Активен' : 'Не активен'}
      </Tag>
    ),
    width: 40,
  },
  {
    field: 'insurance_company',
    headerName: 'Страхователь',
    renderCell: (data: any) => data?.case?.policy?.insurance_program?.insurance_company?.name,
    width: 200,
  },
  {
    field: 'user',
    headerName: 'Клиент',
    renderCell: (data: any) =>
      data?.case?.policy?.last_name +
      ' ' +
      data?.case?.policy?.first_name +
      ' ' +
      (data?.case?.policy?.patronymic || ''),
    width: 200,
  },
  {
    field: 'id',
    headerName: '№ Полиса',
    renderCell: (data: any) => data?.case?.policy?.policy_number,
    width: 150,
  },
  {
    field: 'insurance_program',
    headerName: 'Программа покрытия',
    renderCell: (data: any) => data?.case?.policy?.insurance_program?.name,
    width: 180,
  },
  {
    field: 'policy_start_date',
    headerName: 'Начало страхования',
    renderCell: (data: any) => dayjs(data?.case?.policy?.policy_start_date).format('DD/MM/YYYY'),
    width: 180,
  },
  {
    field: 'policy_end_date',
    headerName: 'Окончание страхования',
    renderCell: (data: any) => dayjs(data?.case?.policy?.policy_end_date).format('DD/MM/YYYY'),
    width: 180,
  },
];

export const collepseColumns = [
  {
    field: 'name',
    headerName: 'Услуга',
    width: 200,
  },
  {
    field: 'limit_amount',
    headerName: 'Стоимость',
    renderCell: (data: any) => convertToReadable(data?.limit_amount || 0) + ' ' + 'UZS',
    width: 200,
  },
  {
    field: 'amount',
    headerName: 'Остаток',
    renderCell: (data: any) => convertToReadable(data?.amount || 0) + ' ' + 'UZS',
    width: 200,
  },
];
